<script setup lang="ts">
defineProps<{ song: { name: string; accepted?: boolean; outline?: boolean } }>()
</script>

<template>
  <div class="student-v2-staircase-song">
    <v-icon v-if="song.accepted" key="2">heart-full</v-icon>
    <v-icon v-else-if="song.outline" key="1">heart-outline</v-icon>
    <v-icon v-else key="0">heart-gray</v-icon>

    {{ song.name }}
  </div>
</template>

<style lang="scss">
.student-v2-staircase-song {
  display: flex;
  align-items: center;
  gap: 8px;

  .v-icon {
    height: 100%;
    width: auto;
  }
}
</style>
